import { 
  INITIALIZE_FOLDERS,
  SET_CURRENT_PATH,
  SET_FOLDER_TREE,
  SET_SNACKBAR
} from "../actions/folderActionsType";

export default (state, action) => {
  switch (action.type) {
    case INITIALIZE_FOLDERS: {
      const {folders, currentPath} = action.foldersInfo;
      return {
        ...state,
        folderTree: folders,
        currentPath: [currentPath]
      }
    }
    case SET_FOLDER_TREE: {
      return {
        ...state,
        folderTree: action.folders
      }
    }
    case SET_CURRENT_PATH: {
      return {
        ...state,
        currentPath: action.currentPath
      }
    }
    case SET_SNACKBAR: {
      return {
        ...state,
        snackbar: action.snackbar
      }
    }
    default:
      return state;
  }
};